import React from 'react';
import Helper from "../functions/Helper.js";
import CouponCode from  '../components/CouponCode.jsx';


const banners={"1": {shop:"eastbay",height:40,margin:0},
               "4": {shop:"finishline",height:18,margin:11},
                "3": {shop:"champssports",height:40,margin:0},
                "2": {shop:"footlocker",height:30,margin:5}
              }


export default class DiscountCoupon extends React.Component {


  render(){
    let height=banners[this.props.shop_id].height;
    let margin=banners[this.props.shop_id].margin;


    return(
      <div>
        <div style={{backgroundColor:"#fbf6ee",border:  "2px dashed #888888",color:"#333333",textAlign:"center",paddingTop:10,paddingBottom:10,marginBottom:20,}}>
          <a className="notunderline" target="_blank"  rel="nofollow noopener noreferrer" href={Helper.insert_link(this.props.link,this.props.linkText,this.props.tracking_id)}>
            <img style={{height:height,marginTop:margin,marginBottom:margin}}  alt="coupon" src={"/" +this.props.banner}/>
            <div  style={{fontSize:20,fontWeight:'bold',color:"black"}}>
              {this.props.name}
            </div>
          </a>
          <div style={{fontSize:16}}>
            <CouponCode style={{fontSize:16,color:"#2780e3",fontWeight:"bold",lineHeight:1.2,marginTop:5,marginBottom:5}}
              code={this.props.code} name= {"coupon_overview"}/>
          </div>
          <div style={{fontSize:14}}>
            Expires {this.props.end}
          </div>
        </div>
      </div>
    );
  }
}
